module.exports = __webpack_public_path__ + "img/mastercard.29be4f18.svg";